




























































































































import Vue from "vue";
import AppTopBar from "./AppTopbar.vue";
import AppProfile from "./AppProfile.vue";
import AppMenu from "./AppMenu.vue";
import AppFooter from "./AppFooter.vue";
import env from "../environments/env.json";
import { getStudioKuerzel, ZnaRequestError } from "./api/http";
import { Studio } from "./api/Studio";

export default Vue.extend({
  data(): any {
    return {
      layoutMode: "overlay",
      layoutColorMode: "dark",
      staticMenuInactive: true,
      overlayMenuActive: false,
      mobileMenuActive: false,
      notAuthenticated: false,
      isLoginRoute: false,
      menu: [],
      menuProd: [],
      menuDev: [
        { label: "Home", icon: "pi pi-fw pi-users", to: "/" },
        { label: "Dashboard", icon: "pi pi-fw pi-home", to: "/dashboard" },
        {
          label: "Fullscreen",
          icon: "pi pi-fw pi-window-maximize",
          to: "/fullscreen",
        },
        {
          label: "Menu Modes",
          icon: "pi pi-fw pi-cog",
          items: [
            {
              label: "Static Menu",
              icon: "pi pi-fw pi-bars",
              command: () => ((this as any).layoutMode = "static"),
            },
            {
              label: "Overlay Menu",
              icon: "pi pi-fw pi-bars",
              command: () => ((this as any).layoutMode = "overlay"),
            },
          ],
        },
        {
          label: "Menu Colors",
          icon: "pi pi-fw pi-align-left",
          items: [
            {
              label: "Dark",
              icon: "pi pi-fw pi-bars",
              command: () => ((this as any).layoutColorMode = "dark"),
            },
            {
              label: "Light",
              icon: "pi pi-fw pi-bars",
              command: () => ((this as any).layoutColorMode = "light"),
            },
          ],
        },
        {
          label: "Components",
          icon: "pi pi-fw pi-globe",
          badge: "9",
          items: [
            {
              label: "Sample Page",
              icon: "pi pi-fw pi-th-large",
              to: "/sample",
            },
            { label: "Forms", icon: "pi pi-fw pi-file", to: "/forms" },
            { label: "Data", icon: "pi pi-fw pi-table", to: "/data" },
            { label: "Panels", icon: "pi pi-fw pi-list", to: "/panels" },
            { label: "Overlays", icon: "pi pi-fw pi-clone", to: "/overlays" },
            { label: "Menus", icon: "pi pi-fw pi-plus", to: "/menus" },
            { label: "Messages", icon: "pi pi-fw pi-spinner", to: "/messages" },
            { label: "Charts", icon: "pi pi-fw pi-chart-bar", to: "/charts" },
            { label: "Misc", icon: "pi pi-fw pi-upload", to: "/misc" },
          ],
        },
        {
          label: "Template Pages",
          icon: "pi pi-fw pi-file",
          items: [
            {
              label: "Empty Page",
              icon: "pi pi-fw pi-circle-off",
              to: "/empty",
            },
          ],
        },
        {
          label: "Menu Hierarchy",
          icon: "pi pi-fw pi-search",
          items: [
            {
              label: "Submenu 1",
              icon: "pi pi-fw pi-bookmark",
              items: [
                {
                  label: "Submenu 1.1",
                  icon: "pi pi-fw pi-bookmark",
                  items: [
                    { label: "Submenu 1.1.1", icon: "pi pi-fw pi-bookmark" },
                    { label: "Submenu 1.1.2", icon: "pi pi-fw pi-bookmark" },
                    { label: "Submenu 1.1.3", icon: "pi pi-fw pi-bookmark" },
                  ],
                },
                {
                  label: "Submenu 1.2",
                  icon: "pi pi-fw pi-bookmark",
                  items: [
                    { label: "Submenu 1.2.1", icon: "pi pi-fw pi-bookmark" },
                    { label: "Submenu 1.2.2", icon: "pi pi-fw pi-bookmark" },
                  ],
                },
              ],
            },
            {
              label: "Submenu 2",
              icon: "pi pi-fw pi-bookmark",
              items: [
                {
                  label: "Submenu 2.1",
                  icon: "pi pi-fw pi-bookmark",
                  items: [
                    { label: "Submenu 2.1.1", icon: "pi pi-fw pi-bookmark" },
                    { label: "Submenu 2.1.2", icon: "pi pi-fw pi-bookmark" },
                    { label: "Submenu 2.1.3", icon: "pi pi-fw pi-bookmark" },
                  ],
                },
                {
                  label: "Submenu 2.2",
                  icon: "pi pi-fw pi-bookmark",
                  items: [
                    { label: "Submenu 2.2.1", icon: "pi pi-fw pi-bookmark" },
                    { label: "Submenu 2.2.2", icon: "pi pi-fw pi-bookmark" },
                  ],
                },
              ],
            },
          ],
        },
        {
          label: "Documentation",
          icon: "pi pi-fw pi-question",
          command: () => {
            window.location.href = "#/documentation";
          },
        },
        {
          label: "View Source",
          icon: "pi pi-fw pi-search",
          command: () => {
            window.location.href = "https://github.com/primefaces/sigma-vue";
          },
        },
      ],
    };
  },
  created() {
    // TODO: Hier könnte z.B. ein Websocket aktiv nach Sperrungen fragen...
    const fn = (() => {
      this.$store.dispatch("appLoading", false);
    }).bind(this);
    setTimeout(fn, 200);
    this.$znaApi.registerAuthErrorObserver((error: ZnaRequestError) => {
      console.log("ZNA-API-Error aufgetreten: ");
      console.log(error);
      if (this.$store.getters["auth/isLoginFlow"]()) {
        console.log("Auth-Fehler während Login ignoriert");
        return;
      }
      if (error && error.request) {
        this.$store.dispatch("auth/onAuthError", { error });

        if (this.$store.getters["auth/backendFehlerAkzeptabel"]()) {
          console.log(
            "Auth-Fehler ignoriert, da letzte Server-Kommunikation kurz genug zurückliegt"
          );
          return;
        }

        this.notAuthenticated = true;
        if (error.request.status == 400) {
          console.log("Kein gültiges Token vorhanden, Weiterleitung zum Login");
          return;
        } else if (error.request.status == 401) {
          console.log(
            "API-Token hat nicht passende Berechtigung oder wurde zurückgezogen"
          );
        }
      }
      if (error && error.response && error.response.data) {
        console.log(error.response.data);
      }
    });
    this.$znaApi.registerSuccessObserver(() => {
      this.notAuthenticated = false;
      this.$store.dispatch("auth/successfulBackendRequest");
    });
  },
  mounted() {
    if (!this.$router.currentRoute.isLoginRoute && this.$znaApi.isAuthenticated()) {
      this.$znaApi.cleanupLocalStorage();
      this.$znaApi.logout();
    }
    this.updatePrivileges();
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
      this.isLoginRoute = this.$router.currentRoute.isLoginRoute;
    },
  },
  methods: {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          this.overlayMenuActive = !this.overlayMenuActive;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event?.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event: any) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element: HTMLElement, className: string) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element: HTMLElement, className: string) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    },
    isSidebarVisible() {
      if (this.isDesktop()) {
        if (this.layoutMode === "static") return !this.staticMenuInactive;
        else if (this.layoutMode === "overlay") return this.overlayMenuActive;
        else return true;
      } else {
        return true;
      }
    },
    updatePrivileges() {
      let useProdMenu = env.isProd;
      useProdMenu = true;
      this.menu = [...(useProdMenu ? this.menuProd : this.menuDev)];
      const menuInsertPos = useProdMenu ? 0 : 1;
      {
        const darfBuchhaltung = this.$znaApi.darfBuchhaltung();
        const darfTagesabschluss = this.$znaApi.darfBuchhaltungTagesabschluss();
        if (darfTagesabschluss || darfBuchhaltung) {
          const buchhaltungSubmenus = [];
          if (darfTagesabschluss) {
            buchhaltungSubmenus.push({
              label: "Tagesabschluss",
              icon: "pi pi-fw pi-bars",
              to: "/tagesabschluss",
            });
          }
          if (darfBuchhaltung) {
            buchhaltungSubmenus.push({
              label: "Kassenbuch",
              icon: "pi pi-fw pi-euro",
              to: "/kassenbuch",
            });
            buchhaltungSubmenus.push({
              label: "Monatsabschluss",
              icon: "pi pi-fw pi-bars",
              to: "/monatsabschluss",
            });
            buchhaltungSubmenus.push({
              label: "Monatsübersicht Studios",
              icon: "pi pi-fw pi-sliders-v",
              to: "/uebersicht-studios",
            });
          }
          this.menu.splice(menuInsertPos, 0, {
            label: "Buchhaltung",
            icon: "pi pi-fw pi-euro",
            items: buchhaltungSubmenus,
          });
        }
      }

      const setStudios = (studios: Studio[]) => {
        this.studios = studios;
        if (this.studios.length == 1) {
          this.$store.dispatch("studioGewaehlt", { studio: this.studio });
        }
        this.menu.splice(
          menuInsertPos,
          0,
          ...studios.map((studio) => {
            const label = "Studioplan " + getStudioKuerzel(studio.bezeichner);
            return {
              label,
              icon: "pi pi-fw pi-align-left",
              to: "/termine/" + studio.bezeichner,
            };
          }),
          {
            label: "Dienstplan",
            icon: "pi pi-fw pi-bars",
            to: "/dienstplan",
          }
        );
      };
      const studios = this.$store.getters["studios"];
      if (Array.isArray(studios) && studios.length >= 1) {
        setStudios(studios);
      } else if (this.$store.getters["auth/isAuthenticated"]) {
        this.$znaApi.getStudios().subscribe((studios: Studio[]) => {
          setStudios(studios);
          this.$store.dispatch("studiosGeladen", { studios: this.studios });
        }),
          (error: ZnaRequestError) => {
            console.log("Studios konnten nicht abgerufen werden");
            console.log(error);
          };
      }

      (this.$refs.appProfile as any).updatePrivileges();
    },

    login() {
      this.$store.dispatch("auth/login", {});
    },
    /*
    logout() {
      this.$znaApi.logout({ url: '/', });
    },
    */
  },
  computed: {
    backgroundCssClass(): string {
      return this.$store.getters.isAppBlocked ? "pause" : "";
    },
    loading(): boolean {
      return this.$store.getters.isAppLoading;
    },
    gesperrt(): boolean {
      return this.$store.getters.isAppBlocked;
    },
    containerClass(): any[] {
      return [
        "layout-wrapper",
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive,
        },
      ];
    },
    sidebarClass(): any[] {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light",
        },
      ];
    },
    logo(): string {
      return this.layoutColorMode === "dark"
        ? "/assets/layout/images/logo-white.svg"
        : "/assets/layout/images/logo.svg";
    },
    showNotAuthenticatedDialog(): boolean {
      return !this.$store.getters["auth/isAuthenticated"] && !this.isLoginRoute;
    },
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    AppProfile: AppProfile,
    AppMenu: AppMenu,
    AppFooter: AppFooter,
  },
});
